<template>
  <b-modal
    title="ثبت دسته بندی جدید سوالات متداول"
    id="modal-faq-category-create"
    centered
    ok-title="ثبت"
    cancel-title="بستن"
    @ok="sendNewFaqCategoryRequest"
    @cancel="clearFaqCreateData"
    :okDisabled="
      !newCategoryDetails.title ||
      !newCategoryDetails.fileData ||
      !newCategoryDetails.slug
    "
  >
    <b-overlay :show="isLoading">
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <b-form-group label="عنوان دسته بندی" label-for="title">
              <b-form-input
                id="title"
                placeholder="ثبت و مدیریت آگهی"
                v-model="newCategoryDetails.title"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="نامک (URL)" label-for="slug">
              <b-form-input
                id="slug"
                placeholder="submit-manage-post"
                v-model="newCategoryDetails.slug"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="عکس دسته بندی" label-for="image">
              <b-form-file
                id="image"
                v-model="tempImageFileData"
                :state="Boolean(tempImageFileData)"
                placeholder="فایل خود را انتخاب کنید"
                @input="setBase64Image"
                drop-placeholder="فایل را اینجا رها کنید"
              ></b-form-file>
            </b-form-group>
            <img
              v-if="newCategoryDetails.fileData"
              :src="newCategoryDetails.fileData"
              style="width: 6rem; height: 6rem; object-fit: contain"
            />
          </b-col>
        </b-form-row>
      </b-container>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  emits: ["reFetch"],
  data() {
    return {
      isLoading: false,
      newCategoryDetails: {
        isDeleted: false,
        title: null,
        order: 0,
        fileData: null,
      },
      tempImageFileData: null,
    };
  },
  methods: {
    clearFaqCreateData() {
      this.tempImageFileData = null;
      this.newCategoryDetails = {
        isDeleted: false,
        title: null,
        order: 0,
        fileData: null,
      };
    },
    closeFaqCreateModal() {
      this.$bvModal.hide("modal-faq-category-create");
      this.clearFaqCreateData();
    },
    async sendNewFaqCategoryRequest(bvModalEvent) {
      bvModalEvent.preventDefault();
      try {
        this.isLoading = true;
        const _this = this;
        const faqCategoryCreateRequest = new FaqCategoryCreateRequest(_this);
        faqCategoryCreateRequest.setParams(_this.newCategoryDetails);
        await faqCategoryCreateRequest.fetch((res) => {
          if (res.isSuccess) {
            this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "دسته بندی جدید با موفقیت ثبت شد",
              },
            });
            _this.closeFaqCreateModal();
            _this.$emit("reFetch");
          } else {
            if (!res.isSuccess && res.errorMessage) {
              this.$toast({
                component: ToastificationContent,
                position: "bottom-center",
                props: {
                  title: "خطا در ثبت دسته بندی",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errorMessage,
                },
              });
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setBase64Image() {
      Helper.createFileAsBase64Image(this.tempImageFileData, (base64) => {
        this.newCategoryDetails.fileData = base64;
      });
    },
  },
  components: {
    BCol,
    BOverlay,
    BFormInput,
    BFormRow,
    BContainer,
    BFormGroup,
    BFormFile,
    BModal,
  },
};
import Helper from "@/libs/Helper";
import { FaqCategoryCreateRequest } from "@/libs/Api/FaqCategory/FaqCategoryRequests";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BCol,
  BOverlay,
  BFormInput,
  BFormRow,
  BContainer,
  BFormGroup,
  BFormFile,
  BModal,
} from "bootstrap-vue";
</script>
